<template>
    <div class="dialog">
        <van-overlay :show="show" @click="hideDialog" :z-index="2100">
            <div class="dialog-wrapper" @click.stop>
                <p class="dialog-content" v-html="content"></p>
                <div class="dialog-wrapper-btn flex justify-between">
                    <van-button class="dialog-wrapper-btn-item" @click="handleLeftBtn" plain color="#009AF3">{{ leftBtnText }}</van-button>
                    <van-button class="dialog-wrapper-btn-item button" @click="handleConfirm">{{ rightBtnText }}</van-button>
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
export default {
    name: "Dialog",
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        content: {
            type: String,
            default: "",
        },
        leftBtnText: {
            type: String,
            default: "取消",
        },
        rightBtnText: {
            type: String,
            default: "确定",
        },
    },
    data() {
        return {};
    },
    methods: {
        handleShowDialog() {
            this.$emit("update:show");
        },
        hideDialog() {
            this.$emit("update:show", false);
        },
        handleLeftBtn() {
            this.$emit("handleLeftBtn");
        },
        handleConfirm() {
            this.$emit("handleConfirm");
        },
    },
};
</script>

<style lang="less" scoped>
.dialog {
    z-index: 2100;
    .button {
        color: #fff;
        background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
    }
    .dialog-wrapper {
        width: 599px;
        height: 319px;
        background: #ffffff;
        border-radius: 20px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        margin: auto;
        .dialog-content {
            font-size: 32px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #212121;
            line-height: 36px;
            text-align: center;
            margin: 80px 0;
        }
        .dialog-wrapper-btn {
            width: 100%;
            padding: 0 32px;
            .dialog-wrapper-btn-item {
                width: 260px;
                height: 70px;
                border-radius: 16px;
                font-size: 32px;
            }
        }
    }
}
</style>
